import { cloneElement } from 'react'
import styles from './toggleButton.module.css'

const ToggleButton = ({
	buttons,
	selected,
	className,
	buttonClass,
	onClick
}) => {
	return (
		<div className={`${styles.toggleButtonContainer} ${className || ''}`}>
			{buttons.map((buttonText, index) => {
				const isSelected =
					selected ===
					(typeof buttonText === 'string'
						? buttonText
						: buttonText.props?.title)
				return typeof buttonText === 'string' ? (
					<button
						type='button'
						key={index}
						data-selected={isSelected}
						className={`${styles.toggleButton} ${buttonClass || ''}`}
						onClick={e => onClick(buttonText, e)}>
						{buttonText}
					</button>
				) : (
					<div
						key={index}
						className={styles.customItem}
						data-selected={isSelected}
						onClick={e => onClick(buttonText.props.title, e)}>
						{cloneElement(buttonText, {
							'data-selected': isSelected,
							className: `${buttonText.props.className || ''} ${
								className || ''
							}`
						})}
					</div>
				)
			})}
		</div>
	)
}

export default ToggleButton